module.exports = __webpack_public_path__ + "assets/Localizable.a8bd0771057773a4db5720600c38a184.strings";


//////////////////
// WEBPACK FOOTER
// ./src/resources/localizable/ru-lproj/Localizable.strings
// module id = 1037
// module chunks = 0